/**
 * @description
 * Handles all actions and provides the basic APIs to handle actions in infra
 */
class ActionsHandler {
  public actionHandlers: { [key: string]: Function };
  constructor() {
    this.actionHandlers = {};
  }

  /**
   * Returns the registered callback function for respective actionName
   * @param actionName name of the action for which call callback is registered
   * @example  <caption>Example for getHandler()</caption>
   * In this example, api returns callback function registered for cancel_Assignment
   * getHandler('cancel_Assignment')
   * @private
   */
  getHandler(actionName: string | number) {
    return this.actionHandlers[actionName];
  }

  /**
   * Registers a call back function specific to an action.
   * @param actionName unique actionName like showHarness etc.,
   * @param handler callback function/handler to register for actionName
   * @example  <caption>Example for registerHandler()</caption>
   * In this example, api registers callback function for cancel_Assignment
   * registerHandler('cancel_Assignment', () => {
   *  console.log('called cancel_Assignment');
   * })
   * @private
   */
  registerHandler(actionName: string | number, handler: Function) {
    this.actionHandlers[actionName] = handler;
  }
}

const actionsHandler = new ActionsHandler();
export default actionsHandler;
